import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  private registerDataArray;
  private snapshotRegisterArray

  registerDataArrayObs: Subject<any> = new Subject();
  constructor(private afs: AngularFirestore) { }



  initRegisterArraySnapshot(userId, deviceId) {


    this.snapshotRegisterArray = this.afs.collection('agActivity').ref.where('parent', '==', userId).where('deviceId', '==', deviceId ).onSnapshot(d => {
      this.registerDataArray = null;
      this.registerDataArray = d.docs.map(v => { return { id: v.id, data: v.data() } });


     // console.log(this.registerDataArray)
      this.registerDataArrayObs.next(this.registerDataArray);
    })
  }

  unsubRegisterArraySnapshot() {
    if (this.snapshotRegisterArray)
      this.snapshotRegisterArray();

  }

  getRegisterArrayData() {
    return this.registerDataArray;
  }

}
